import { SIDE_NAV_LIGHT, NAV_TYPE_TOP, DIR_LTR } from 'constants/ThemeConstant'; 

export const APP_NAME = 'PushPulse';   

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: 'en',
  navType: NAV_TYPE_TOP,
  topNavColor: '#41abe1',
  headerNavColor: '',
  mobileNav: false,
  currentTheme: 'light',
  direction: DIR_LTR
};